module.exports = __webpack_public_path__ + "img/vertical-top-right.c89b414b.png";